// extracted by mini-css-extract-plugin
module.exports = {"container":"ProfileTabPageNavBar_container__nEZrd","sending":"ProfileTabPageNavBar_sending__lrICe"};